var _style, _defs, _g, _defs2, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpatialcitizen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{clip-path:url(#SVGID_00000129188406992718940060000009250830680657464501_);}\n\t.st2{fill:#062746;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{clip-path:url(#SVGID_00000107586699281189509040000013463206075912943257_);}\n\t.st5{fill:#29B7A4;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "0.9,56.2 0.9,26.8 92.3,14 92.3,43.4  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000023270652610781716310000010190207592637261970_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000023270652610781716310000010190207592637261970_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M7.3,26.3c-3.9,0.5-5.9,3.3-5.9,7.8c0,4.3,2.2,6.3,4.5,8.1c1.9,1.6,3.6,3,3.6,5.8c0,2-0.7,3-2.3,3.3 c-1.5,0.2-2.3-0.6-2.3-2.6v-2.1L1.2,47v1.8c0,4.6,2.1,6.7,6,6.1c3.9-0.5,6-3.3,6-7.8c0-4.3-2.2-6.3-4.5-8.1 c-1.9-1.6-3.6-3-3.6-5.8c0-2,0.7-3.1,2.2-3.3c1.5-0.2,2.2,0.6,2.2,2.6v1.2l3.6-0.5v-0.9C13.2,27.8,11.2,25.7,7.3,26.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.1,51.2C8.6,51,9.4,50,9.4,48c0-2.8-1.8-4.2-3.6-5.8c-2.2-1.9-4.5-3.8-4.5-8.1 c0-4.6,2.1-7.3,5.9-7.8c3.9-0.5,5.9,1.6,5.9,6.1v0.9l-3.6,0.5v-1.2c0-2-0.7-2.9-2.2-2.6c-1.5,0.2-2.2,1.3-2.2,3.3 c0,2.8,1.8,4.2,3.6,5.8c2.2,1.9,4.5,3.8,4.5,8.1c0,4.6-2.1,7.3-6,7.8c-3.9,0.5-6-1.6-6-6.1v-1.8l3.6-0.5v2.1 C4.8,50.6,5.5,51.5,7.1,51.2 M7.3,25.9c-4,0.6-6.3,3.5-6.3,8.2c0,4.5,2.4,6.5,4.6,8.4c1.8,1.5,3.5,3,3.5,5.6 c0,1.8-0.6,2.7-2,2.9c-1.4,0.2-2-0.5-2-2.3v-2.4l-4.2,0.6v2.1c0,4.7,2.2,7,6.3,6.4c4.1-0.6,6.3-3.5,6.3-8.2 c0-4.5-2.4-6.5-4.6-8.4c-1.8-1.5-3.5-3-3.5-5.6c0-1.8,0.6-2.7,1.9-2.9c1.3-0.2,1.9,0.5,1.9,2.4v1.5l4.2-0.6v-1.3 C13.5,27.7,11.3,25.4,7.3,25.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.7,38.5l0-10l2.1-0.3c1.5-0.2,2.2,0.6,2.2,2.5V35c0,2-0.7,2.9-2.2,3.1L19.7,38.5 M21.9,24.6 l-5.9,0.8l0,28.1l3.8-0.5l0-10.7l2.1-0.3c4-0.6,6-3.1,6-7.7v-3.7C27.9,26,25.9,24,21.9,24.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20,38.1v-9.3l1.8-0.2c1.3-0.2,1.9,0.5,1.9,2.2v4.2c0,1.8-0.5,2.6-1.9,2.8L20,38.1 M21.9,28.3 l-2.1,0.3l0,10l2.1-0.3c1.5-0.2,2.2-1.2,2.2-3.1v-4.2C24.1,28.8,23.4,28.1,21.9,28.3 M15.9,53.5l0-28.1l5.9-0.8 c4-0.6,6,1.5,6,6v3.7c0,4.5-2,7.2-6,7.7l-2.1,0.3l0,10.7L15.9,53.5 M21.9,24.2l-6.3,0.9l0,28.7l4.5-0.6l0-10.7l1.8-0.2 c4.1-0.6,6.3-3.4,6.3-8.1v-3.7C28.2,25.8,26,23.6,21.9,24.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.7,42.3l2.2-16l2.1,15.4L33.7,42.3 M39,22.2L33.2,23L29,51.6l3.5-0.5l0.7-5.3l5.4-0.7l0.7,5 l3.9-0.5L39,22.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M34.1,41.9l1.8-13.3l1.8,12.8L34.1,41.9 M35.9,26.3l-2.2,16l4.4-0.6L35.9,26.3 M29,51.6L33.2,23 l5.8-0.8l4.1,27.5l-3.9,0.5l-0.7-5l-5.4,0.7l-0.7,5.3L29,51.6 M39.3,21.8L33,22.7L28.6,52l4.1-0.6l0.7-5.3l4.8-0.7l0.7,5 l4.5-0.6L39.3,21.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "56.8,19.7 44.3,21.4 44.3,25.1 48.6,24.5 48.6,48.9 52.4,48.3 52.4,24 56.8,23.4 56.8,19.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.3,25.1v-3.7l12.5-1.8v3.7L52.4,24l0,24.3l-3.8,0.5l0-24.3L44.3,25.1 M57.1,19.3L44,21.1v4.4 l4.3-0.6l0,24.3l4.5-0.6l0-24.3l4.3-0.6L57.1,19.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "62.7,18.8 59,19.3 58.9,47.4 62.7,46.9 62.7,18.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M58.9,47.4l0-28.1l3.8-0.5l0,28.1L58.9,47.4 M63.1,18.4l-4.5,0.6l0,28.7l4.5-0.6L63.1,18.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M69.7,37.2l2.2-16L74,36.6L69.7,37.2 M75,17.1l-5.8,0.8L65,46.5l3.5-0.5l0.7-5.3l5.4-0.7l0.7,5 l3.9-0.5L75,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70,36.8l1.8-13.3l1.8,12.8L70,36.8 M71.9,21.2l-2.2,16l4.4-0.6L71.9,21.2 M65,46.6l4.2-28.6l5.8-0.8 l4.1,27.5l-3.9,0.5l-0.7-5l-5.4,0.7l-0.7,5.3L65,46.6 M75.2,16.7l-6.3,0.9l-4.3,29.1l0,0.2l4.1-0.6l0.7-5.3l4.8-0.7l0.7,5 l4.5-0.6L75.2,16.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "85.2,15.7 81.4,16.2 81.3,44.2 92,42.7 92,39 85.2,40 85.2,15.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M81.3,44.2l0-28.1l3.8-0.5l0,24.3l6.8-1v3.7L81.3,44.2 M85.5,15.3l-4.5,0.6l0,28.7l11.3-1.6v-4.4 l-6.8,1L85.5,15.3"
  }))))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000157306210920117168530000017379439319214396581_",
    points: "8.3,86 8.4,56.6 99.1,43.8 99.1,73.3  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000164482881701998340430000009244705221892007079_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000157306210920117168530000017379439319214396581_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000164482881701998340430000009244705221892007079_)"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M14.7,56.1c-3.9,0.5-6,3.3-6,7.8l0,14.8c0,4.6,2.1,6.7,6,6.1c3.9-0.5,6-3.3,6-7.8v-3.6l-3.6,0.5v3.9 c0,2-0.7,3-2.3,3.3c-1.5,0.2-2.3-0.6-2.3-2.6l0-15.3c0-2,0.8-3.1,2.3-3.3c1.5-0.2,2.3,0.7,2.3,2.6v2.9l3.6-0.5v-2.6 C20.7,57.6,18.6,55.5,14.7,56.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M14.6,84.8c-3.9,0.5-6-1.6-6-6.1l0-14.8c0-4.6,2.1-7.3,6-7.8c3.9-0.5,6,1.6,6,6.1v2.6l-3.6,0.5v-2.9 c0-2-0.7-2.9-2.3-2.6c-1.5,0.2-2.3,1.3-2.3,3.3l0,15.3c0,2,0.7,2.8,2.3,2.6c1.5-0.2,2.3-1.3,2.3-3.3v-3.9l3.6-0.5v3.6 C20.7,81.5,18.6,84.2,14.6,84.8 M14.7,55.7c-4.1,0.6-6.3,3.5-6.3,8.2l0,14.8c0,4.7,2.2,7,6.3,6.4c4.1-0.6,6.3-3.5,6.3-8.2 V73l-4.2,0.6v4.2c0,1.8-0.6,2.7-2,2.9c-1.4,0.2-2-0.5-2-2.3l0-15.3c0-1.8,0.6-2.7,2-2.9c1.4-0.2,2,0.6,2,2.4v3.2l4.2-0.6 v-2.9C21,57.4,18.8,55.1,14.7,55.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "27.3,54.6 23.5,55.1 23.5,83.2 27.3,82.7 27.3,54.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.5,83.2l0-28.1l3.8-0.5l0,28.1L23.5,83.2 M27.7,54.3l-4.5,0.6l0,28.7l4.5-0.6L27.7,54.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "42,52.6 29.5,54.3 29.5,58 33.9,57.4 33.8,81.8 37.6,81.2 37.7,56.9 42,56.3 42,52.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M29.5,58v-3.7L42,52.6v3.7l-4.3,0.6l0,24.3l-3.8,0.5l0-24.3L29.5,58 M42.3,52.2L29.2,54v4.4l4.3-0.6 l0,24.3l4.5-0.6l0-24.3l4.3-0.6L42.3,52.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "48,51.7 44.2,52.3 44.1,80.3 48,79.8 48,51.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M44.1,80.3l0-28.1l3.8-0.5l0,28.1L44.1,80.3 M48.3,51.3L43.9,52l0,28.7l4.5-0.6L48.3,51.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "62.5,49.7 51.1,51.3 51.1,55 58.6,53.9 50.6,75.6 50.6,79.4 62.4,77.7 62.4,74 54.5,75.2  62.5,53.5 62.5,49.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M51.1,55v-3.7l11.4-1.6v3.8l-8,21.7l7.9-1.1v3.7l-11.8,1.6v-3.8l8-21.7L51.1,55 M62.8,49.3l-12,1.7 v4.4l7.4-1l-7.8,21.2l0,4.2L62.8,78v-4.4L55,74.7l7.8-21.2L62.8,49.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "76.2,47.7 65.3,49.3 65.2,77.3 76.2,75.8 76.2,72.1 69,73.1 69.1,64.4 74.7,63.7 74.7,59.9  69.1,60.7 69.1,52.5 76.2,51.5 76.2,47.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.2,77.3l0-28.1l11-1.5v3.7l-7.2,1v8.3l5.7-0.8v3.7L69,64.5v8.7l7.2-1v3.7L65.2,77.3 M76.5,47.4 L64.9,49l0,28.7l11.6-1.6v-4.4l-7.2,1v-8l5.7-0.8v-4.4l-5.7,0.8v-7.6l7.2-1L76.5,47.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "91.9,45.6 88.5,46 88.5,64.1 84,46.7 79.1,47.4 79,75.4 82.4,74.9 82.5,53.2 87.8,74.2  91.8,73.6 91.9,45.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.5,64.1l0-18.1l3.4-0.5l0,28.1l-4,0.6l-5.4-20.9l0,21.7L79,75.4l0-28.1l4.9-0.7L88.5,64.1  M92.2,45.2l-4,0.6l0,15.9l-3.9-15.3l-5.5,0.8l0,28.7l4-0.6l0-19.4l4.8,18.8l4.5-0.6L92.2,45.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "98.8,68.7 95.1,69.2 95.1,73.2 98.8,72.7 98.8,68.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.1,73.2v-4l3.7-0.5v4L95.1,73.2 M99.1,68.3l-4.3,0.6v4.6l4.3-0.6V68.3"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpatialcitizen);
export default __webpack_public_path__ + "static/media/spatialcitizen.6c13f3d4ac017cc2a6a65f103aaa10f1.svg";
export { ForwardRef as ReactComponent };